export default __webpack_public_path__ + "static/media/news23.e787d2a6.jpg";